import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

export const useNewUrlParams = () => {
  const location = useLocation();
  const params = useMemo(() => new URLSearchParams(location.search), [location.search]);
  // console.log('useNewUrlParams', {location, params})
  return params;
};
